<template>
  <div class="MyMapWelcomeBlock" v-if="!userStore.userIsLogged && !isClosed">
    <h2>{{ $t('myMap.leftSidebar.welcome.title') }}</h2>
    <img src="@/assets/images/logo-sigcom.png" alt="Logo SIGCOM" class="MyMapWelcomeBlock__logo" />
    <p>{{ $t('myMap.leftSidebar.welcome.description') }}</p>
    <div class="MyMapWelcomeBlock__moreAccess">
      <span>{{ $t('myMap.leftSidebar.welcome.moreAccess') }}</span>
      <BaseButton @click="handleLoginClick" type="button" width="w-full" height="h-11">
        {{ $t('myMap.leftSidebar.welcome.login') || 'Se connecter' }}
      </BaseButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/userStore'
import BaseButton from '@/components/ui/BaseButton.vue'
import { useRouter } from 'vue-router'
import { RoutesKey } from '@/models/enums/app/RoutesKey'
import { ref } from 'vue'

const userStore = useUserStore()
const router = useRouter()
const isClosed = ref(false)

const handleLoginClick = () => {
  router.push({ name: RoutesKey.AUTH_SIGN_IN })
}
</script>

<style lang="scss">
.MyMapWelcomeBlock {
  display: flex;
  flex-flow: column nowrap;
  gap: var(--panel-section-gap);
  padding: 2.5rem 1.5rem;
  width: 100%;
  align-items: center;
  text-align: center;
  min-width: 19rem !important;
  align-self: flex-end;

  h2 {
    color: rgb(var(--v-theme-main-blue));
    font-size: 1.125rem;
    font-weight: 600;
    line-height: 1.3;
    margin: 0;
  }

  p {
    font-size: var(--font-size-sm);
    color: var(--panel-label-color);
    line-height: 1.5;
    margin: 0;
  }

  .MyMapWelcomeBlock__logo {
    max-width: 200px;
    width: 100%;
    height: auto;
    margin: 0 auto;
    display: block;
  }

  .MyMapWelcomeBlock__moreAccess {
    display: flex;
    flex-flow: column nowrap;
    gap: 0.75rem;
    padding: 1rem;
    border-radius: var(--dim-radius);
    background: rgb(var(--v-theme-surface));
    border: 1px solid var(--neutral-border);
  }
  .MyMapWelcomeBlock__close {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
